module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00094.19af8bab.jpg";